import { RouteHttpVerb } from "@devowl-wp/utils";
export const locationRestJobsDelete = {
    path: "/jobs",
    method: RouteHttpVerb.DELETE
};
